import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpHeaders,
} from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { SeguroStore } from '@interfaces/seguro-store.interface';
import { Store } from '@services/store.service';
import { LoginService } from '@providers/login.service';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private store: Store<SeguroStore>,
    private loginService: LoginService
  ) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    const state = this.store.getState();
    const httpHeaders = new HttpHeaders({});
    if (state?.token) {
      req = req.clone({
        headers: httpHeaders.append('Authorization', 'bearer ' + state.token),
      });
      return next.handle(req);
    } else {
      return from(this.loginService.obtenerToken()).pipe(
        switchMap((respuesta) => {
          const res: SeguroStore = this.loginService.procesarToken(respuesta);

          this.store.setState({
            ...state,
            token: res.token,
          });
          req = req.clone({
            headers: httpHeaders.append('Authorization', 'bearer ' + res.token),
          });
          return next.handle(req);
        })
      );
    }
  }
}
